import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  type SelectChangeEvent,
  Typography
} from '@mui/material'
import EditNotificationsIcon from '@mui/icons-material/EditNotifications'
import OutboxIcon from '@mui/icons-material/Outbox'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { Formik } from 'formik'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useCreateMailMutation, useSendMailMutation } from '../../../../api-services/asset-holdings/assetHolderApi'
import { setNotification } from '../../../components/ui-widgets/uiWidgetsSlice'
import { useAppDispatch } from '../../../../app/hooks'
import TextField from '@mui/material/TextField'

const CreateEmailNotificationPage: React.FC = (props: any) => {
  const history = useHistory()
  const dispatch = useAppDispatch()

  const [reportType, setReportType] = useState<string>('')
  const [groupKey, setGroupKey] = useState<string>('')

  const goTo = (location: string): void => {
    history.push(location)
  }

  const [apiCreateMailTrigger] = useCreateMailMutation()
  const [apiSendMailTrigger] = useSendMailMutation()

  const handleReportTypeChange = (event: SelectChangeEvent): void => {
    setReportType(event.target.value)
  }

  const readyToSend = (): boolean => {
    return reportType !== '' && groupKey !== ''
  }

  const handleBackAction = (): void => {
    goTo('/app/distributions/emails')
  }

  const createEmailOnSubmit = async (): Promise<void> => {
    const createEmailPayload = { reportType }
    const choice = window.confirm(
      'Are you sure you want to create the email?'
    )
    if (choice) {
      apiCreateMailTrigger(createEmailPayload)
        .unwrap()
        .then((triggerResult) => {
          setGroupKey(triggerResult.groupKey)
          // handleBackAction()
          dispatch(setNotification({ open: true, severity: 'success', message: `Email created successfully. ${triggerResult.countPerStatus} created.` }))
        })
        .catch((err: any) => {
          dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
        })
    }
  }

  const handleSendEmail = (): void => {
    const sendEmailPayload = { reportType, groupKey }
    const choice = window.confirm(
      'Are you sure you want to send the emails?'
    )
    if (choice) {
      apiSendMailTrigger(sendEmailPayload)
        .unwrap()
        .then((triggerResult) => {
          // handleBackAction()
          dispatch(setNotification({ open: true, severity: 'success', message: 'Emails are being sent out.' }))
        })
        .catch((err: any) => {
          dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
        })
    }
  }

  return (
    <>
      <Formik
        initialValues={ { reportType, groupKey } }
        onSubmit={async (values, actions) => {
          await createEmailOnSubmit()
        }}
      >
        {formikProps => (

          <form
            autoComplete={'off'}
            autoCorrect={'off'}
            onSubmit={formikProps.handleSubmit}
          >

            <Grid container>
              <Grid item lg={12}>
                <Grid container sx={{ mb: 4 }}>
                  <Grid item lg={8}>
                    <Typography variant={'h5'}>
                      Create Email Notifications
                    </Typography>
                  </Grid>
                  <Grid item lg={4} sx={{ textAlign: 'right' }}>
                    <Button variant={'outlined'} onClick={() => {
                      handleBackAction()
                    }} startIcon={<ArrowBackIcon />}>
                      Back
                    </Button>
                  </Grid>
                </Grid>

                <Paper>
                  <Box sx={{ p: 4, mt: 3 }}>
                    <Grid container sx={{ mb: 4 }} spacing={4}>
                      <Grid item md={12}>
                        <FormControl sx={{ width: '100%' }}>
                          <InputLabel>Report Type</InputLabel>
                          <Select
                            value={reportType}
                            label={'Report Type'}
                            disabled={false}
                            onChange={handleReportTypeChange}
                          >
                            <MenuItem key={'SOLAR_GENERATION_REPORT'} value={'SOLAR_GENERATION_REPORT'}>Solar Generation Report</MenuItem>
                            <MenuItem key={'SOLAR_PAYMENTS_REPORT'} value={'SOLAR_PAYMENTS_REPORT'}>Solar Payments Report</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item md={12}>
                        <TextField label={'Group Key'}
                                   value={groupKey}
                                   type={'text'}
                                   disabled={true}
                                   sx={{ width: '100%' }}
                        />
                      </Grid>

                    </Grid>

                    <Grid container spacing={4}>
                      <Grid item lg={9} sx={{ mt: 3 }}>
                        {
                          !readyToSend() && (
                            <Button variant={'contained'} startIcon={<EditNotificationsIcon/>} type={'submit'} sx={{ mr: 3 }}>
                              Create New Email Group
                            </Button>
                          )
                        }
                        {
                          readyToSend() && (
                            <Button color={'secondary'} variant={'contained'} startIcon={<OutboxIcon />} sx={{ mr: 3 }} onClick={() => {
                              handleSendEmail()
                            }}>
                              Send Email Group
                            </Button>
                          )
                        }

                        <Button type={'button'} variant={'text'} onClick={() => {
                          handleBackAction()
                        }}>
                          Cancel
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </>
  )
}

export default CreateEmailNotificationPage
